<template>
  <div class="mt-3 p-2">
    <b-container fluid class="mb-2">
      <b-row class="mb-2">
        <b-col md="6">
          <h5 class="text-uppercase heading">Assets</h5>
        </b-col>
        <b-col md="6" class="text-right">
          <assets-create @create="fetchData"></assets-create>
          <!-- asset edit start -->
          <b-modal id="modal-2" title="Edit Asset" size="xl" hide-footer>
      <b-alert variant="success" v-if="success" show> {{ success }}</b-alert>
      <div>
        <b-tabs content-class="mt-3">
          <b-tab title="Plantation" active>
            <b-form @submit.prevent="updateFormSubmitted" enctype="multipart/form-data">
              <div class="row">

                <div class="col-md-6">
                 
                  <b-form-group
                    id="input-group-1"
                    label="Name:"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      v-model="form.name"
                      type="text"
                      placeholder="Enter Asset Name"
                      required
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="input-group-2"
                    label="Code:"
                    label-for="input-2"
                  >
                    <b-form-input
                      id="input-2"
                      v-model="form.code"
                      placeholder="Enter Asset Code"
                      required
                    ></b-form-input>
                  </b-form-group>

                  <b-form-group
                    id="input-group-2"
                    label="Description:"
                    label-for="input-2"
                  >
                    <b-form-textarea
                      id="input-2"
                      v-model="form.description"
                      placeholder="Enter description..."
                      rows="5"
                      max-rows="8"
                    ></b-form-textarea>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    id="input-group-2"
                    label="Grade:"
                    label-for="input-2"
                  >
                    <b-form-select
                      id="input-2"
                      v-model="form.grade"
                      placeholder="Enter Grade"
                      required
                    >
                     <template #first>
                        <b-form-select-option value="" disabled>Select Grade</b-form-select-option>
                    </template>
                    <b-form-select-option value="A" selected>Grade A</b-form-select-option>
                    <b-form-select-option value="B">Grade B</b-form-select-option>
                    <b-form-select-option value="C">Grade C</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
                  <b-form-group
                    id="input-group-2"
                    label="Plant Category:"
                    label-for="input-2"
                  >
                
                    <b-form-select
                      v-model="form._plantAssetCategoryID"
                      :options="options"
                      value-field="_id"
                      text-field="name"
                    >
                    <template #first>
                        <b-form-select-option value="" disabled>Select Plant Category</b-form-select-option>
                    </template>
                     
                     </b-form-select>

                  </b-form-group>

                  <b-form-group
                    id="input-group-2"
                    label="Image:"
                    label-for="input-2"
                  >
                 
                    <b-form-file
                      id="file1"
                      ref="file1"
                      v-model="form.image"
                      :state="Boolean(form.image)"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                     
                    ></b-form-file>
                  </b-form-group>
                 
                  <img  :src="temp_image" class="img-fluid">
                </div>
                <div class="col-md-12">
                  <b-button size="sm" type="submit" variant="success" > Update </b-button>
                  
                </div>
              </div>
            </b-form>
          </b-tab>
          <b-tab title="Live Stock" disabled><p>Live Stock</p></b-tab>
          <b-tab title="Fixed Asset" disabled><p>Fixed Asset</p></b-tab>
          <b-tab title="Cottage" disabled><p>Fixed Asset</p></b-tab>
        </b-tabs>
      </div>
    </b-modal>
         
          <!-- asset edit end -->
        </b-col>
      </b-row>

      <b-row class="mb-4">
        <b-col md="2">
          <!-- Select User Per Page  -->
          <b-form-select v-model="item_per_page" @change="changeItemNumber">
            <b-form-select-option value="10">10</b-form-select-option>
            <b-form-select-option value="50">50</b-form-select-option>
            <b-form-select-option value="100">100</b-form-select-option>
          </b-form-select>
        </b-col>
        <b-col md="9">
          <!-- Filter -->
          <b-form-group label="" label-for="filter-input" class="mb-0">
            <b-input-group>
              <b-form-input id="filter-input" v-model="filter" type="search"
                placeholder="Type to Search"></b-form-input>

              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="1" class="d-flex justify-content-end">
          <b-button variant="success" @click="downloadCSV">
            <i class="fa fa-download" aria-hidden="true"></i>
          </b-button>
        </b-col>
      </b-row>

      <b-table class="dataTable rounded-left" :outlined="true" :items="items" :fields="fields" :filter="filter"
        @filtered="filtered" :per-page="perPage" :current-page="currentPage" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" head-variant="none" table-variant="none" :busy="isBusy">
        <template #cell(#)="data">
          <span v-if="currentPage == 1">{{ data.index + 1 }}</span>
          <span v-else>{{
          (currentPage - 1) * item_per_page + (data.index + 1)
          }}</span>
        </template>

        <template #cell(actions)="row">
          <router-link :to="'/asset/' + row.item._id"><i class="fas fa-eye view-icon" aria-hidden="true"></i>
          </router-link>
          <div   @click="editButtonClicked(row.item)">
            <i class="fas fa-edit view-icon"></i>
          </div>
        </template>

        <template #cell(created_ts)="data">
          {{ data.item.created_ts | moment('ddd,Do MMM YYYY') }}
        </template>

        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <div class="d-flex justify-content-center mt-4">
        <b-pagination pills v-model="currentPage" :total-rows="rows" :per-page="perPage"
          aria-controls="my-table"></b-pagination>
      </div>
    </b-container>
  </div>
</template>

<script>
import assetsCreate from '@/components/assets/create';
import moment from 'moment';
export default {
  name: 'Users',
  components: {
    assetsCreate,
  },
  data() {
    return {
      success:false,
      item_per_page: 10,
      perPage: 10,
      currentPage: 1,
      sortBy: 'name',
      sortDesc: false,
      filter: null,
      isBusy: false,
     
      fields: [
        '#',
        {
          key: '_assetCategoryID.name',
          label: 'Category',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true,
        },
        {
          key: 'code',
          label: 'Code',
          sortable: true,
        },
        {
          key: 'grade',
          label: 'Grade',
          sortable: true,
        },
        {
          key: 'created_ts',
          label: 'Registration Date',
          sortable: true,
        },
        'actions',
      ],
      items: [],
      downloadItems: [],
      form: {
        name: "",
        code: "",
        image: "",
        description: "",
        grade: "",
        _plantAssetCategoryID: "",
      },
      options: [],
      plantCategoriesOptions: [],
      temp_image:''
    };
  },
  mounted() {
    this.fetchData();
    this.getplantCategoryType();
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },

  methods: {
    getplantCategoryType() {
      window.axios.get("assets/plant/category/list").then((resp) => {
        this.options = resp.data.data;
      });
    },
    uploadImage1() {
      this.form.image = this.$refs.file1.files[0];
      console.log(this.$refs.file1.files[0]);
      console.log("this.$refs.file1.files[0]");
      alert("Test")

    },
    filtered(filteredItems) {
      this.downloadItems = filteredItems;
    },
    changeItemNumber() {
      this.perPage = this.item_per_page;
    },
    fetchData() {
      this.isBusy = true;
      window.axios.get('/assets').then((resp) => {
        console.log(resp.data.data);
        if (resp.data.success) {
          this.items = resp.data.data;
          this.downloadItems = this.items;
          this.isBusy = false;
        }
        
      });
    },
    updateFormSubmitted(){
      let formData = new FormData();
      formData.append("_id", this.form._id);
      formData.append("image", this.form.image);
      formData.append("name", this.form.name);
      formData.append("code", this.form.code);
      formData.append("description", this.form.description);
      formData.append("grade", this.form.grade);
      formData.append("_plantAssetCategoryID", this.form._plantAssetCategoryID);

      window
        .axios({
          method: "PUT",
          url: "assets",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((resp) => {
          if (resp.data.success) {
            alert("success");
            window.location.reload();
          }
         
        });
    },
    editButtonClicked(data){
      this.$bvModal.show('modal-2')
      this.temp_image= data.image;
      this.form =  {
        _id: data._id,
        name: data.name,
        code: data.code,
        description: data.description,
        grade: data.grade,
        image:data.image,
        _plantAssetCategoryID: data._plantAssetCategoryID._id,
      }
    },
    downloadCSV() {
      let csv = '\ufeff' + 'CATEGORY,NAME,CODE,GRADE,REGISTRATION DATE\n';
      this.downloadItems.forEach((el) => {
        var line =
          el['_assetCategoryID'].name +
          ',' +
          el['name'] +
          ',' +
          el['code'] +
          ',' +
          el['grade'] +
          ',' +
          `${moment(el['created_ts']).format('DD-MM-YYYY')}` +
          '\n';
        csv += line;
      });
      var blob = new Blob([csv], { type: 'csv/plain' });
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'Assets.csv';
      link.click();
    },
  },
};
</script>

<style scoped>
.heading {
  font-family: 'Poppins', sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 3.5%;
  margin-top: 5px;
  margin-bottom: 5px;
  color: #454545;
}

.view-icon {
  color: #1da040;
  height: 20px;
  width: 30px;
}

/deep/ .dataTable thead {
  background-color: #dcffd9;
  height: 64px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 3.5%;
  font-family: 'Poppins', sans-serif;
  padding-top: 14px;
  padding-bottom: 14px;
  color: #303030;
}

/deep/ .dataTable {
  text-align: center;
  margin-bottom: 21.5px;
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

/deep/ .dataTable tr td {
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  letter-spacing: 3.5%;
  line-height: 25.5px;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
